import {NolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/NolimitAudioPlayer";
import {IFadeTrackConf, IPlayTrackConf} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {gsap} from "gsap";
import {NolimitHowl} from "@nolimitcity/slot-audio/bin/NolimitHowl";
import {XwaysHoarder2} from "../XwaysHoarder2";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";


export class XwaysHoarder2Sound {

    public static START_GAME: string = "startGame";

    public static REELS_SPINNING: string = "reelsSpinning";
    public static REELS_LANDING: string[] = ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5"];
    public static REEL_LANDIND_LAST: string = "reelLanding6";
    public static AS_WIN: string = "countupEndMid";
    public static AS_WIN_BIG: string = "bigwinEnd";

    public static COUNTUP: string = "countup";
    public static COUNTUP_END_TINY: string = "countupEndTiny";
    public static COUNTUP_END_SMALL: string = "countupEndSmall";
    public static COUNTUP_END_MID: string = "countupEndMid";
    public static COUNTUP_END_LARGE: string = "countupEndLarge";
    public static BIGWIN_INTRO: string = "bigwinIntro";
    public static BIGWIN_END: string = "bigwinEnd";
    public static BIGWIN_LEVELS: string[] = ["bigwin1", "bigwin2", "bigwin3", "bigwin4", "bigwin5"];


    //scatter sounds
    public static SCATTER_LANDING_1: string = "scatterLanding1";
    public static SCATTER_LANDING_2: string = "scatterLanding2";
    public static SCATTER_LANDING_3: string = "scatterLanding3";
    public static LAST_REEL_LANDING_SCATTER_WIN: string = "reelLanding6ScatterWin";
    public static SCATTER_WIN_ALREADY_PLAYED: boolean = false;
    public static SCATTER_ANTICIPATION: string = "scatterAnticipation";
    public static SCATTER_ANTICIPATION_FAIL: string = "scatterAnticipationFail";
    public static SCATTER_WIN: string = "scatterWin";
    public static SCATTER_XSPLIT: string = "scattersToXsplit";


    public static FS_END_BAD: string = "fsEndBad";
    public static FS_END_GOOD: string = "fsEndGood";

    // mode transition sounds
    public static CONTINUE_BUTTON: string = "continueButton";
    public static FS_CONTINUE_BUTTON: string = "fsIntroContinueButton";
    public static BONUS_DOOR_CLOSE: string = "fsGateClose";
    public static BONUS_DOOR_OPEN: string = "fsGateOpen"
    public static BONUS_DOOR_CHANGE_LEVEL: string = "moveScreen";
    public static BONUS_INTRO_START: string = "fsIntroStart";
    public static BONUS_INTRO_COUNTUP: string = "fsIntroSpinCountup";

    //bonus level up sounds
    public static RADIATION_ANIMATION: string = "fsRadiation";
    public static BINGE_INTRO: string = "bingeIntro";
    public static SYMBOL_REMOVE_CROSS: string = "fsRadiationHighlightSymbols";


    //bonus outro sounds
    public static OUTRO_PROGRESS_LIGHT: string = "fsOutroProgressLight";
    public static OUTRO_PROGRESS_LIGHT_LEVEL: string = "fsOutroProgressLightLevel";
    public static OUTRO_PROGRESS_MOVE_DOWN: string = "fsOutroProgressMoveDown";
    public static OUTRO_SIGN_SCALE_IN: string = "fsOutroSignScaleIn";
    public static OUTRO_SIGN_FALL_DOWN: string = "fsOutroSignFallDown";
    public static OUTRO_SHOTS: string = "fsOutroShots";

    // win cap sounds
    public static CAP_COUNT_UP: string = "capCountup";
    public static CAP_LOOP: string = "capLoop";


    //sound loops
    public static MAIN_GAME_MUSIC: string = "main";
    public static FS_MUSIC: string = "freespin";
    public static SFS_MUSIC: string = "freespin";
    public static SFS_LEVEL_4_MUSIC: string = "super_freespin_level_4"
    public static BONUS_INTRO: string = "bonusIntro";
    public static BONUS_OUTRO: string = "bonusOutro";
    public static BONUS_OUTRO_END: string = "bonusOutroEnd";


    //respin sounds
    public static RESPIN_SYMBOL_LANDING: string="respinSymbolLanding";
    public static RESPIN_SYMBOL_EXPANSION: string="respinSymbolExpand";
    public static RESPIN_VOICE_N_MUSIC: string[][]=[["respinRadioVoice1","respinMusic1"],["respinRadioVoice2","respinMusic2"],["respinRadioVoice3","respinMusic3"]];
    public static RESPIN_ALARM: string = "alarm";
    public static RESPIN_MUSIC_ENDS: string = "respinMusicEnds";
    public static RESPIN_MUSIC_US: string = "respinMusic3_PA";

    // Sticky sounds
    public static TAPE_ON: string = "respinDuctTapeOn";
    public static TAPE_OFF: string = "respinDuctTapeOff";

    // XWay Sounds
    public static XWAY_LAND: string = "xWaysLanding";
    public static XWAY_EXPAND: string = "xWaysExpand";
    public static XWAY_CLOSE: string = "xWaysClose";
    public static XWAY_CONNECTS: string = "xWaysConnects";
    public static XWAY_EXPAND_FAST: string = "xWaysExpandFast";

    // Radiation sounds
    public static SCREAM_M4: string = "fsRadiationScreamM6";
    public static SCREAM_M5: string = "fsRadiationScreamM5";
    public static SCREAM_M6: string = "fsRadiationScreamM4";

    // Betline
    public static BETLINE_SWEEPS: string [] = ["betlineSweep1", "betlineSweep2", "betlineSweep3"];

    // X-split
    public static XSPLIT_LAND: string = "xSplitLanding";
    public static XSPLIT_TO_WILD: string = "xSplitToWild";
    public static XSPLIT_SPLIT: string = "xSplitSplit";
    public static XSPLIT_RESPIN_TO_WILD: string = "xSplitWildToXsplit";

    // XSplit Nudge Sound
    public static XSPLIT_NUDGE_LAND: string = "xSplitNudgeLanding";
    public static XSPLIT_NUDGE_NUDGE: string = "xSplitNudgeNudge";
    public static XSPLIT_NUDGE_TO_WILD: string = "xSplitNudgeToWild";
    public static XSPLIT_NUDGE_ARROW: string = "xSplitNudgeArrow";

    // +1
    public static FS_PLUS: string = "fsPlusSpin";

    // Elevator sounds
    public static ELEVATOR: string = "elevator";
    public static ELEVATOR_STOP: string = "elevatorStops";
    public static ELEVATOR_PANEL: string = "elevatorPanel";

    // FS Indicator Progress Sounds
    public static INDICATOR_SCALE_UP: string = "fsProgressScaleUp";
    public static INDICATOR_SCALE_DOWN: string = "fsProgressScaleDown";
    public static INDICATOR_LIGHT: string = "fsProgressLight";
    public static INDICATOR_BINGE: string = "fsProgressLightBinge";

    private static davidPanningReelStop: number[] = [-0.17, -0.09, -0.02, -0.02, 0.09, 0.17];
    private static _currentMusic: string;
    private _player: NolimitAudioPlayer;

    public static LAST_RESPIN_MUSIC: string = "";

    constructor() {
        this._player = <NolimitAudioPlayer>XwaysHoarder2.sound;
        this._player.showLogs(true);
    }

    public static get soundPlayer(): NolimitAudioPlayer {
        return <NolimitAudioPlayer>XwaysHoarder2.sound;
    }

    public static switchMusic(conf: IPlayTrackConf, fadeInConf?: IFadeTrackConf, fadeOutConf?: IFadeTrackConf): void {
        if (conf.name === XwaysHoarder2Sound._currentMusic) {
            return;
        }

        if (XwaysHoarder2Sound._currentMusic != null) {
            if (fadeOutConf) {
                fadeOutConf.name = this._currentMusic;
                const fade = XwaysHoarder2Sound.soundPlayer.fadeTrack(fadeOutConf);
                const fadeName = this._currentMusic;
                if (fade) {
                    gsap.to(this, {
                        duration: fadeOutConf.duration / 1000,
                        onComplete: () => {
                            XwaysHoarder2Sound.soundPlayer.stopTrack(fadeName);
                        }
                    });
                } else {
                    XwaysHoarder2Sound.soundPlayer.stopTrack(fadeName);
                }
            } else {
                XwaysHoarder2Sound.soundPlayer.stopTrack(XwaysHoarder2Sound._currentMusic);
            }
        }

        XwaysHoarder2Sound.soundPlayer.playTrack(conf);
        if (fadeInConf) {
            XwaysHoarder2Sound.soundPlayer.fadeTrack(fadeInConf);
        }
        XwaysHoarder2Sound._currentMusic = conf.name;
    }

    // Use this to handle the music, eg, fade out/in music in big win, and you don't need to care what music is playing
    public static fadeMusic(vol: number, duration: number): void {
        XwaysHoarder2Sound.soundPlayer.fadeTrack({
            name: XwaysHoarder2Sound._currentMusic,
            to: vol,
            duration: duration
        });
    }


    private static CUR_FADE_OUT_TRACKS: string [] = [];
    private static CUR_FADE_IN_TRACKS: string [] = [];

    public static fadeOutButDoNotStopMusic(nameFadeOut: string, durationOut: number): void {
        XwaysHoarder2Sound.soundPlayer.fadeTrack({
            name: nameFadeOut,
            to: 0,
            duration: durationOut
        });
        XwaysHoarder2Sound.CUR_FADE_OUT_TRACKS.push(nameFadeOut);
    }

    public static fadeSpecificMusic(name: string, vol: number, duration: number): void {
        XwaysHoarder2Sound.soundPlayer.fadeTrack({
            name: name,
            from: 0,
            to: vol,
            duration: duration
        });
        XwaysHoarder2Sound.CUR_FADE_IN_TRACKS.push(name);
    }


    public static fadeInPreviousMusic(durationOut: number, durationIn: number): void {
        const popOut = XwaysHoarder2Sound.CUR_FADE_IN_TRACKS.pop();
        const popIn = XwaysHoarder2Sound.CUR_FADE_OUT_TRACKS.pop();

        if(popOut && popIn) {
            XwaysHoarder2Sound.soundPlayer.fadeTrack({
                name: popOut,
                to: 0,
                duration: durationOut
            });

            XwaysHoarder2Sound.soundPlayer.fadeTrack({
                name: popIn,
                to: 1,
                duration: durationIn
            });
        }
    }

    public static playTrack(soundName: string, vol?: number, repeat?: number): NolimitHowl | undefined {
        return XwaysHoarder2Sound.soundPlayer.playTrack({name: soundName, volume: vol, repeat: repeat});
    }

    public static fadeOutAndStopSound(fadeOutConf: IFadeTrackConf): void {
        const fade = XwaysHoarder2Sound.soundPlayer.fadeTrack(fadeOutConf);
        if (fade) {
            gsap.to(this, {
                duration: fadeOutConf.duration / 1000,
                onComplete: () => {
                    XwaysHoarder2Sound.soundPlayer.stopTrack(fadeOutConf.name);
                }
            });
        } else {
            XwaysHoarder2Sound.soundPlayer.stopTrack(fadeOutConf.name);
        }
    }

    public static fadeInAndStartSound(fadeOutConf: IFadeTrackConf): void {
        const fade = XwaysHoarder2Sound.soundPlayer.fadeTrack(fadeOutConf);
        if (fade) {
            gsap.to(this, {
                duration: fadeOutConf.duration / 1000,
                onComplete: () => {
                    XwaysHoarder2Sound.soundPlayer.playTrack({name: fadeOutConf.name, volume: fadeOutConf.to});
                }
            });
        } else {
            XwaysHoarder2Sound.soundPlayer.playTrack({name: fadeOutConf.name});
        }
    }

    public static stopSound(name: string): void {
        XwaysHoarder2Sound.soundPlayer.stopTrack(name);
    }

    public static playLandingSound(reelId: number): void {
        const sound: NolimitHowl | undefined = this.soundPlayer.playTrack({
            name: reelId !== 5 ? this.REELS_LANDING[reelId] : this.REEL_LANDIND_LAST,
            repeat: 0
        });
        if (sound) {
            sound.player.stereo(this.davidPanningReelStop[reelId]);
        }
    }

    public static shuffleReelLanding(): void {
        ArrayHelper.shuffle(this.REELS_LANDING);
    }

    private static createConfig(name: string, volume?: number, repeat?: number): IPlayTrackConf {
        return {
            name: name,
            volume: volume,
            repeat: repeat
        };
    }

}
